export enum KruxEvent {
    FIRE_EVENT_PIXEL = 'kruxFireEventPixel',
}

export interface IKruxEvent extends CustomEvent {
    detail: any
}
